// extracted by mini-css-extract-plugin
export var cartContainer = "_na-4";
export var gray = "_na-1";
export var itemContainer = "_na-2";
export var itemDetails = "_na-3";
export var strong = "_na-0";